const projectGroups = [
    {
        slug: 'new-life-center-channel-letters',
        title: 'New Life Center',
        category: { en: 'Illuminated Channel Letters', es: 'Channel letters iluminados' },
        summary: {
            en: 'Illuminated channel letters installed on a brick storefront for strong day-and-night visibility.',
            es: 'Channel letters iluminados instalados en una fachada de ladrillo para lograr visibilidad de día y de noche.'
        },
        services: {
            en: ['Channel letter installation', 'LED illumination', 'Final alignment'],
            es: ['Instalación de channel letters', 'Iluminación LED', 'Alineación final']
        },
        media: [
            { type: 'image', src: '/services/channel-letter-installation-new-life.jpg', alt: 'New Life Center illuminated channel letters during installation' },
            { type: 'image', src: '/gallery/new-life-center/new-life-center-channel-letters-01.webp', alt: 'Close view of the New Life Medical Center channel letters during final installation' },
            { type: 'image', src: '/gallery/new-life-center/new-life-center-channel-letters-02.webp', alt: 'Completed New Life Medical Center channel letter sign at night' },
            { type: 'video', src: '/gallery/new-life-center/new-life-center-installation-drone.mp4', poster: '/gallery/new-life-center/new-life-center-installation-drone-poster.jpg', alt: 'Drone view of the New Life Medical Center channel letter installation' }
        ]
    },
    {
        slug: 'las-mercedes-channel-letter-installation',
        title: 'Las Mercedes Family Clinic',
        category: { en: 'Channel Letter Installation', es: 'Instalación de channel letters' },
        summary: {
            en: 'Professional elevated installation of large channel letters on a commercial building in Houston.',
            es: 'Instalación profesional en altura de channel letters de gran formato en un edificio comercial de Houston.'
        },
        services: {
            en: ['Elevated installation', 'Storefront positioning', 'Final inspection'],
            es: ['Instalación en altura', 'Posicionamiento en fachada', 'Inspección final']
        },
        media: [{ type: 'video', src: '/videos/channel-letter-installation.mp4', poster: '/videos/channel-letter-installation-poster.jpg', alt: 'Las Mercedes Family Clinic channel letter installation' }]
    },
    {
        slug: 'hartman-properties-ada-signage',
        title: 'Hartman Properties',
        portfolioCategory: 'ada-signs',
        category: { en: 'ADA & Property Signage', es: 'Señalización ADA y para propiedades' },
        summary: {
            en: 'Ongoing signage work for commercial properties, including ADA room identification with tactile characters and Braille, tenant identification, and exterior property signage.',
            es: 'Trabajos continuos de señalización para propiedades comerciales, incluyendo identificación ADA de oficinas con caracteres táctiles y Braille, identificación de inquilinos y rótulos exteriores.'
        },
        services: {
            en: ['ADA room identification signs', 'Tactile lettering and Braille', 'Tenant and property signage', 'Professional installation and updates'],
            es: ['Rótulos ADA para identificación de oficinas', 'Letras táctiles y Braille', 'Señalización de inquilinos y propiedades', 'Instalación y actualización profesional']
        },
        media: [
            { type: 'image', src: '/gallery/hartman-properties/hartman-properties-ada-sign-04.webp', alt: 'ADA office identification sign with tactile room number and Braille for a Hartman Properties location' },
            { type: 'image', src: '/gallery/hartman-properties/hartman-properties-ada-sign-03.webp', alt: 'ADA room identification sign with tactile lettering and Braille installed at a Hartman Properties location' },
            { type: 'image', src: '/gallery/hartman-properties/hartman-properties-ada-sign-02.webp', alt: 'Hartman Properties exterior leasing sign at a commercial office building' },
            { type: 'image', src: '/gallery/hartman-properties/hartman-properties-ada-sign-01.webp', alt: 'Updated exterior tenant monument sign at a commercial property' }
        ]
    },
    {
        slug: 'tex-pro-electrical',
        title: 'Tex-Pro Electrical LLC',
        category: { en: 'Vehicle Graphics', es: 'Gráficos vehiculares' },
        summary: {
            en: 'Custom branding and professional vinyl installation for a Chevrolet Silverado service truck.',
            es: 'Identidad visual personalizada e instalación profesional de vinilo para una camioneta Chevrolet Silverado de servicio.'
        },
        services: {
            en: ['Custom graphic design', 'Vinyl production', 'Professional installation'],
            es: ['Diseño gráfico personalizado', 'Producción de vinilo', 'Instalación profesional']
        },
        media: [
            { type: 'image', src: '/gallery/g14.jpg', alt: 'Tex-Pro Electrical vehicle graphics on Chevrolet Silverado' },
            { type: 'video', src: '/gallery/v2.mp4', poster: '/gallery/v2-thumb.jpg', alt: 'Tex-Pro vinyl installation process' }
        ]
    },
    {
        slug: 'elevate-acrylic-sign',
        title: 'Elevate',
        category: { en: 'Interior Acrylic Sign', es: 'Rótulo interior de acrílico' },
        summary: {
            en: 'Clear acrylic reception sign featuring the Elevate logo in modern blue tones.',
            es: 'Rótulo transparente de acrílico para recepción con el logotipo de Elevate en tonos azules modernos.'
        },
        services: { en: ['Sign production', 'Acrylic finishing', 'Wall mounting'], es: ['Producción del rótulo', 'Acabado en acrílico', 'Montaje en pared'] },
        media: [{ type: 'image', src: '/gallery/g16.jpg', alt: 'Elevate acrylic reception sign' }]
    },
    {
        slug: 'lulis-multiservices',
        title: 'Lulis Multiservices LLC',
        category: { en: 'Corporate Interior Signage', es: 'Señalización corporativa interior' },
        summary: {
            en: 'Professional acrylic reception sign presenting the company brand and its principal services.',
            es: 'Rótulo profesional de acrílico para recepción que presenta la marca y sus servicios principales.'
        },
        services: { en: ['Layout preparation', 'Acrylic sign production', 'Corporate signage'], es: ['Preparación del diseño', 'Producción en acrílico', 'Señalización corporativa'] },
        media: [{ type: 'image', src: '/gallery/g18.jpg', alt: 'Lulis Multiservices corporate acrylic sign' }]
    },
    {
        slug: 'los-parritas',
        title: 'Los Parritas de Nuevo León',
        category: { en: 'Trailer Graphics', es: 'Gráficos para remolque' },
        summary: {
            en: 'Full-color promotional graphics created for the rear gate of a music group trailer.',
            es: 'Gráficos promocionales a todo color creados para el portón trasero del remolque de un grupo musical.'
        },
        services: { en: ['Promotional design', 'Large-format printing', 'Trailer application'], es: ['Diseño promocional', 'Impresión de gran formato', 'Aplicación en remolque'] },
        media: [{ type: 'image', src: '/gallery/g15.jpg', alt: 'Los Parritas de Nuevo León trailer graphics' }]
    },
    {
        slug: 'campana-y-cumaco',
        title: 'Campana y Cumaco',
        category: { en: 'Retractable Promotional Banner', es: 'Banner promocional retráctil' },
        summary: {
            en: 'Vibrant vertical promotional design created for cultural and community events.',
            es: 'Diseño promocional vertical y vibrante creado para eventos culturales y comunitarios.'
        },
        services: { en: ['Graphic design', 'High-resolution printing', 'Retractable display'], es: ['Diseño gráfico', 'Impresión de alta resolución', 'Exhibidor retráctil'] },
        media: [{ type: 'image', src: '/gallery/g17.jpg', alt: 'Campana y Cumaco retractable promotional banner' }]
    },
    {
        slug: 'la-violeta-cuban',
        title: 'La Violeta Cuban',
        category: { en: 'Commercial Banner Installation', es: 'Instalación de banner comercial' },
        summary: {
            en: 'Professional storefront banner installation, from surface preparation through the final clean finish.',
            es: 'Instalación profesional de banner en fachada, desde la preparación de la superficie hasta el acabado final.'
        },
        services: { en: ['Surface preparation', 'Banner installation', 'Final alignment'], es: ['Preparación de superficie', 'Instalación del banner', 'Alineación final'] },
        media: [{ type: 'video', src: '/gallery/v4.mp4', poster: '/gallery/v4-thumb.jpg', alt: 'La Violeta Cuban commercial banner installation' }]
    }
];

export default projectGroups;
